import {
  createAdminApi,
  deleteAdminApi,
  getAdminsApi,
  getAdminApi,
  updateAdminApi,
} from "api/admins";
import {
  takeEvery,
  fork,
  put,
  all,
  call,
  takeLatest,
} from "redux-saga/effects";
import {
  createAdminFailure,
  createAdminSuccess,
  deleteAdminFailure,
  deleteAdminSuccess,
  getAdminsFailure,
  getAdminsSuccess,
  getAdminFailure,
  getAdminSuccess,
  updateAdminFailure,
  updateAdminSuccess,
} from "./actions";
import {
  CREATE_ADMIN,
  DELETE_ADMIN,
  GET_ADMINS,
  GET_ADMIN,
  UPDATE_ADMIN,
} from "./actionTypes";

function* getAdminsSaga({ payload }) {
  try {
    const { data } = yield call(getAdminsApi, payload);
    yield put(getAdminsSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getAdminsFailure(error));
  }
}

// ===================================================
// ===================================================

function* getAdminSaga({ payload }) {
  try {
    const { data } = yield call(getAdminApi, payload);
    yield put(getAdminSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getAdminFailure(error));
  }
}

// ===================================================
// ===================================================

function* createAdminSaga({ payload }) {
  try {
    const { data, success } = yield call(createAdminApi, payload);
    yield put(createAdminSuccess(data));
    if (success === "true") {
      yield payload?.toast?.success("تم إنشاء المشرف بنجاح");
      yield payload?.navigate("/admins");
    }
  } catch (error) {
    console.log(error);
    yield put(createAdminFailure(error));
    yield payload?.toast?.error(error?.response?.data?.message);
  }
}

// ===================================================
// ===================================================

function* updateAdminSaga({ payload }) {
  try {
    const { data, success } = yield call(updateAdminApi, payload);
    yield put(updateAdminSuccess(data));
    if (success === "true") {
      yield payload?.toast?.success("تم تحديث المشرف بنجاح");
      yield payload?.navigate("/admins");
    }
  } catch (error) {
    console.log(error);
    yield put(updateAdminFailure(error));
    yield payload?.toast?.error(error?.response?.data?.message);
  }
}

// ===================================================
// ===================================================

function* deleteAdminSaga({ payload }) {
  try {
    yield call(deleteAdminApi, payload);
    yield put(deleteAdminSuccess(payload));
  } catch (error) {
    console.log(error);
    yield put(deleteAdminFailure(error));
    yield payload?.toast?.error(error?.response?.data?.message);
  }
}

// ===================================================
// ===================================================

export function* watchGetAdmins() {
  yield takeEvery(GET_ADMINS, getAdminsSaga);
}

export function* watchGetAdmin() {
  yield takeLatest(GET_ADMIN, getAdminSaga);
}

export function* watchCreateAdmin() {
  yield takeLatest(CREATE_ADMIN, createAdminSaga);
}

export function* watchUpdateAdmin() {
  yield takeLatest(UPDATE_ADMIN, updateAdminSaga);
}
export function* watchDeleteAdmin() {
  yield takeLatest(DELETE_ADMIN, deleteAdminSaga);
}

// ===================================================
// ===================================================

function* adminsSaga() {
  yield all([fork(watchGetAdmins)]);
  yield all([fork(watchGetAdmin)]);
  yield all([fork(watchDeleteAdmin)]);
  yield all([fork(watchUpdateAdmin)]);
  yield all([fork(watchCreateAdmin)]);
}

export default adminsSaga;
